import React from "react";
import CardContentButtons from 'components/tile/CardContentButtons';
import FavoriteButton from 'components/FavoriteButton';
import WebComponent from "./WebComponent";
import LoginModalBtn from 'components/auth/buttons/LoginModalBtn';


class ContentActionButtons extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      trailmixModalOpen: false
    };

    this.addButtons()
  }

  componentDidMount() {
    document
      .getElementsByTagName('th-trailmix-add-modal')[0]
      .addEventListener("requestclose", (e) => this.closeTrailmixModal())
  }

  addButtons() {
    this.buttons = [];
    this.buttons.push(this.favoriteButton());

    // Show add to trailmix button only for content types we support in trailmixes.
    const isEmployeeTrail = this.props?.content?.isEmployeeTrail;
    const isEmployeeModule = this.props?.content?.isEmployeeModule;
    const isTrailSeries = this.props?.content?.isTrailSeries;
    if (!isEmployeeTrail && !isEmployeeModule && !isTrailSeries) {
      this.buttons.push(this.addToTrailmixButton())
    }
  }

  isMarqueeFavoriteActionsContext() {
    const { className } = this.props;
    return !!className?.split(/\s+/).includes("marquee__favorite-actions");
  }

  favoriteButton() {
    const {
      user,
      renderAsButton,
      labels,
      content: { apiName, type, contentType }
    } = this.props;

    if (type === 'customstep' || type === 'trailmix') return null;
    const isEmployeeModule = this.props?.content?.isEmployeeModule;
    const tactBadgeSupportEnabled = this.props?.content?.tactBadgeSupportEnabled;
    if (isEmployeeModule && !tactBadgeSupportEnabled) return null;
    const authenticated = !!user;

    const isFavorite = !!(this.props.user && this.props.user.favorited);
    const favKey = `${type}-${apiName}-${isFavorite}`;
    if (type !== 'preview_module') {
      return (
        <FavoriteButton
          favorited={isFavorite}
          authenticated={authenticated}
          apiName={apiName}
          contentType={contentType}
          type={type}
          key={favKey}
          renderAsButton={renderAsButton}
          labels={labels}
        />
      )
    }
  }

  trailmixModal() {
    const {
      content: {
        apiName,
        type,
        contentUid,
        path,
        color,
        image,
        subtitle,
        title,
        description,
        timeLeft,
        points,
      }
    } = this.props;

    let slug = null;
    if (this.props.user) {
      slug = this.props.user.slug
    }

    // Override type for agentblazer_trail to trail
    const modalType = type === 'agentblazer_trail' ? 'trail' : type;

    return (
        <WebComponent
          tagName="th-trailmix-add-modal"
          attrs={{
            config: {
              learning: {
                name: apiName,
                type: modalType.toUpperCase(),
              },
              ...(slug && {
                user: {
                  username: slug,
                },
              }),
            },
            open: this.state.trailmixModalOpen,
            summary: {
              id: contentUid,
              path: path,
              color: color,
              type: modalType.toUpperCase(),
              image: image,
              pretitle: subtitle,
              title: title,
              description: description,
              estimatedTime: timeLeft,
              points: points,
            },
          }}
        />
    )
  }
  
  closeTrailmixModal = () => {
    this.setState({
      trailmixModalOpen: false
    })
  }

  openTrailmixModal = () => {
    this.setState({
      trailmixModalOpen: true
    })
  }

  addToTrailmixButton() {
    const wrapperStyle = this.isMarqueeFavoriteActionsContext() ? undefined : {width: "100%"};

    if (!this.props.user) {
      return (
        <div style={wrapperStyle}>
          <LoginModalBtn
            content={this.props.trailmixButtonLabels.addToTrailmix}
            className="slds-grid slds-button slds-button_neutral th-content-card__button"
          />
        </div>
      )
    }
    return (
      <div style={wrapperStyle}>
        <button
          className="slds-grid slds-button slds-button_neutral th-content-card__button"
          onClick={this.openTrailmixModal}
          aria-label={""}
        >
        <span>
          {this.props.trailmixButtonLabels.addToTrailmix}
        </span>
      </button>
    </div>
    );
  }

  render() {
  const { className } = this.props;
  const fullWidthButtons = !this.isMarqueeFavoriteActionsContext();

  return (
    <div>
      <div className={`slds-grow tds-content__buttons ${className || ""}`} style={{fontSize: "1rem"}}>
        {this.buttons && (
          <CardContentButtons buttons={this.buttons} fullWidth={fullWidthButtons} />
        )}
      </div>
      {this.trailmixModal()}
    </div>


  );
}
}

export default ContentActionButtons;
